import { Fade } from '@mui/material';
import type { ChangeEventHandler, HTMLInputAutoCompleteAttribute } from 'react';
import { TransitionGroup } from 'react-transition-group';

import { InputType } from '@/components/BaseLibrary/FormInput/FormInput';
import { maskInputChangeEvent } from '@/utils/utils';

import useStyles from './Input.styles';

interface Props {
  label?: string;
  value: string;
  maxLength?: number;
  error?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onEnterKeyDown?: (e: React.KeyboardEvent) => void;
  containerClass?: string;
  inputClass?: string;
  placeholder?: string;
  type?: InputType;
  inputMode?: React.HTMLAttributes<'input'>['inputMode'];
  autocomplete?: HTMLInputAutoCompleteAttribute;
}

/**
 * @deprecated V2 component
 */
export default function Input({
  label,
  value,
  maxLength,
  error,
  onChange,
  onEnterKeyDown,
  containerClass,
  inputClass,
  placeholder,
  type = InputType.TEXT,
  inputMode = 'text',
  autocomplete,
}: Props) {
  const { classes } = useStyles();

  const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    const maskedEvent = maskInputChangeEvent(event, type);
    onChange(maskedEvent);
  };

  return (
    <div className={containerClass || classes.container}>
      {/** biome-ignore lint/a11y/noLabelWithoutControl: Automated migration to Biome */}
      {label && <label className={classes.formLabel}>{label}</label>}
      <input
        className={inputClass || classes.input}
        value={value}
        onChange={handleChange}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && onEnterKeyDown !== undefined) {
            onEnterKeyDown(e);
          }
        }}
        type='text'
        maxLength={maxLength}
        placeholder={placeholder}
        inputMode={inputMode}
        autoComplete={autocomplete}
      ></input>
      <TransitionGroup className={classes.error}>
        {error?.length && (
          <Fade timeout={500} in={!!error.length}>
            <p>{error}</p>
          </Fade>
        )}
      </TransitionGroup>
    </div>
  );
}
